<div class="w-100-p" fxLayout="column">
    <div class="delta-dialog-toolbar h-64 pl-24 pr-24 pt-20 pb-20" fxLayout="row" fxLayoutAlign="space-between center">
		<span class="title">{{"Share via email"|translate}}</span>
		<mat-icon class="close cursor-pointer" matTooltip="{{ 'CLOSE_DIALOG' | translate }}"
			matTooltipPosition="above" (click)="dialogRef.close()">close</mat-icon>
	</div>
    <div class="field m-16 mb-0">
        <mat-form-field appearance="outline" class="w-100-p">
            <mat-label>Email Address</mat-label>
            <input matInput [(ngModel)]="email" name="Email" 
            pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            #Email="ngModel" type="email" class="form-control" required>
            <mat-error [hidden]="Email.valid">Email invalid</mat-error>
        </mat-form-field>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-actions class="mx-24 my-4" fxLayout="row" fxLayoutAlign="space-between center">
		<button mat-button class="delta-button"
			(click)="dialogRef.close()">{{'CANCEL'|translate}}
		</button>
		<button mat-raised-button class="delta-button w-100" color="primary" (click)="send()"
			[disabled]="!Email.valid">{{'SEND'|translate}}
		</button>
	</div>

</div>